import { reactive, onBeforeMount } from "@vue/composition-api";
import router from "@/router";
// import errorHandle from "@/lib/errorHandle.ts";

export default function displayUIStore() {
  // errorHandle();
  const state = reactive({
    loading: false,
    searching: false,
    drawer: false,
    headerSub: true,
    isDetail: false,
    currentSearchComponent: "SearchInputBoxMain",
    currentBankComponent: "Bank",
    sortModal: false,
    sortType: "work_start_date",
    errorAlert: "",
    snackbar: false,
    snackMessage: '',
    snackbarType: '',

    //admin
    admin: {
      dialogDeleteAdmin: false,
      dialogDeleteAdminCompany: false,
      dialogCompanyEvaluation: false,
      dialogDeleteAdminRecruitment: false,
      dialogAdminRecruitmentChat: false,
      dialogMemberEvaluation: false,
      dialogProcess: false,
    },

    //company
    company: {
      dialogEvaluationList: false,
      dialogDeleteJob: false,
      dialogDeleteJobDraf : false,
      dialogJobSearch: false,
      dialogFeatureSearch: false,
      dialogSkillSearch: false,
      dialogUpdateCompanyInfor: false,
      dialogRegisterCard: false,
      dialogUnlikeUser: false,
      dialogLikeUser: false,
      dialogConfirmAccount: false,
      dialogUpdateJobDraft: false,
      //error dialog
      dialogRecruitmentError: false,
      dialogCompanyError: false,
      dialogCardError: false,
      dialogLoginError: false,
      //create
      dialogConfirmCreate: false,
      //勤怠関連
      dialogAttendance: false,
      dialogAbsence: false,
    }
  });

  return {
    get loading() {
      return state.loading;
    },

    get searching() {
      return state.searching;
    },

    toggleSearching() {
      return (state.searching = !state.searching);
    },

    toTopPage() {
      this.leaveSearching();
      this.leaveDrawer();
      router.push("/");
    },

    leaveSearching() {
      return (state.searching = false);
    },
    onSearching() {
      return (state.searching = true);
    },
    get drawer() {
      return state.drawer;
    },
    toggleDrawer() {
      return (state.drawer = !state.drawer);
    },
    leaveDrawer() {
      return (state.drawer = false);
    },

    //snackbar
    get snackbar() {
      return state.snackbar;
    },
    get snackMessage() {
      return state.snackMessage;
    },
    get snackbarType() {
      return state.snackbarType;
    },

    //admin
    get dialogDeleteAdmin() {
      return state.admin.dialogDeleteAdmin;
    },
    get dialogDeleteAdminCompany() {
      return state.admin.dialogDeleteAdminCompany;
    },
    get dialogCompanyEvaluation() {
      return state.admin.dialogCompanyEvaluation;
    },
    get dialogDeleteAdminRecruitment() {
      return state.admin.dialogDeleteAdminRecruitment;
    },
    get dialogAdminRecruitmentChat() {
      return state.admin.dialogAdminRecruitmentChat;
    },
    get dialogMemberEvaluation() {
      return state.admin.dialogMemberEvaluation;
    },
    get dialogProcess() {
      return state.admin.dialogProcess;
    },

    openDeleteAdminDialog() {
      state.admin.dialogDeleteAdmin = true;
    },
    closeDeleteAdminDialog() {
      state.admin.dialogDeleteAdmin = false;
    },
    openDeleteAdminCompanyDialog() {
      state.admin.dialogDeleteAdminCompany = true;
    },
    closeDeleteAdminCompanyDialog() {
      state.admin.dialogDeleteAdminCompany = false;
    },
    openCompanyEvaluationDialog() {
      state.admin.dialogCompanyEvaluation = !state.admin.dialogCompanyEvaluation;
    },
    closeCompanyEvaluationDialog() {
      state.admin.dialogCompanyEvaluation = false;
    },
    openAdminRecruitmentDialog() {
      state.admin.dialogDeleteAdminRecruitment = !state.admin.dialogDeleteAdminRecruitment;
    },
    closeAdminRecruitmentDialog() {
      state.admin.dialogDeleteAdminRecruitment = false;
    },
    openAdminRecruitmentChatDialog() {
      state.admin.dialogAdminRecruitmentChat = !state.admin.dialogAdminRecruitmentChat;
    },
    closeAdminRecruitmentChatDialog() {
      state.admin.dialogAdminRecruitmentChat = !state.admin.dialogAdminRecruitmentChat;
    },
    openMemberEvaluationDialog() {
      state.admin.dialogMemberEvaluation = !state.admin.dialogMemberEvaluation;
    },
    closeMemberEvaluationDialogDialog() {
      state.admin.dialogMemberEvaluation = !state.admin.dialogMemberEvaluation;
    },
    openProcessDialog() {
      state.admin.dialogProcess = !state.admin.dialogProcess;
    },
    closeProcessDialog() {
      state.admin.dialogProcess = !state.admin.dialogProcess;
    },

    //company
    get dialogEvaluationList() {
      return state.company.dialogEvaluationList;
    },
    openEvaluationListDialog() {
      state.company.dialogEvaluationList = true;
    },
    closeEvaluationListDialog() {
      state.company.dialogEvaluationList = false;
    },

    get dialogDeleteJobDraf() {
      return state.company.dialogDeleteJobDraf;
    },
    openDeleteJobDialogDraf() {
      state.company.dialogDeleteJobDraf = true;
    },
    closeDeleteJobDialogDraf() {
      state.company.dialogDeleteJobDraf = false;
    },
    
    get dialogDeleteJob() {
      return state.company.dialogDeleteJob;
    },
    openDeleteJobDialog() {
      state.company.dialogDeleteJob = true;
    },
    closeDeleteJobDialog() {
      state.company.dialogDeleteJob = false;
    },

    get dialogAttendance() {
      return state.company.dialogAttendance;
    },
    openAttendanceDialog(){
      state.company.dialogAttendance = true;
    },
    closeAttendanceDialog(){
      state.company.dialogAttendance = false;
    },

    get dialogAbsence() {
      return state.company.dialogAbsence;
    },
    openAbsenceDialog(){
      state.company.dialogAbsence = true;
    },
    closeAbsenceDialog(){
      state.company.dialogAbsence = false;
    },

    get dialogJobSearch() {
      return state.company.dialogJobSearch;
    },
    openJobSearchDialog() {
      state.company.dialogJobSearch = true;
    },
    closeJobSearchDialog() {
      state.company.dialogJobSearch = false;
    },

    get dialogFeatureSearch() {
      return state.company.dialogFeatureSearch;
    },
    openFeatureSearchDialog() {
      state.company.dialogFeatureSearch = true;
    },
    closeFeatureSearchDialog() {
      state.company.dialogFeatureSearch = false;
    },

    get dialogSkillSearch() {
      return state.company.dialogSkillSearch;
    },
    openSkillSearchDialog() {
      state.company.dialogSkillSearch = true;
    },
    closeSkillSearchDialog() {
      state.company.dialogSkillSearch = false;
    },

    get dialogUpdateCompanyInfor() {
      return state.company.dialogUpdateCompanyInfor;
    },
    openDialogUpdateComInfor() {
      state.company.dialogUpdateCompanyInfor = true;
    },
    closeDialogUpdateComInfor() {
      state.company.dialogUpdateCompanyInfor = false;
    },

    get dialogConfirmCreateCompany() {
      return state.company.dialogConfirmCreate;
    },
    openDialogConfirmCreateCompany() {
      state.company.dialogConfirmCreate = true;
    },
    closeDialogConfirmCreateCompany() {
      state.company.dialogConfirmCreate = false;
    },

    

    get dialogRegisterCard() {
      return state.company.dialogRegisterCard;
    },
    openDialogRegisterCard() {
      state.company.dialogRegisterCard = true;
    },
    closeDialogRegisterCard() {
      state.company.dialogRegisterCard = false;
    },

    get dialogUnlikeUser() {
      return state.company.dialogUnlikeUser;
    },
    openDialogUnlikeUser() {
      state.company.dialogUnlikeUser = true;
    },
    closeDialogUnlikeUser() {
      state.company.dialogUnlikeUser = false;
    },

    get dialogLikeUser() {
      return state.company.dialogLikeUser;
    },
    openDialogLikeUser() {
      state.company.dialogLikeUser = true;
    },
    closeDialogLikeUser() {
      state.company.dialogLikeUser = false;
    },

    get dialogRecruitmentError() {
      return state.company.dialogRecruitmentError;
    },
    openDialogRecruitmentError() {
      state.company.dialogRecruitmentError = true;
    },
    closeDialogRecruitmentError() {
      state.company.dialogRecruitmentError = false;
    },

    get dialogCompanyError() {
      return state.company.dialogCompanyError;
    },
    openDialogCompanyError() {
      state.company.dialogCompanyError = true;
    },
    closeDialogCompanyError() {
      state.company.dialogCompanyError = false;
    },

    get dialogCardError() {
      return state.company.dialogCardError;
    },
    openDialogCardError() {
      state.company.dialogCardError = true;
    },
    closeDialogCardError() {
      state.company.dialogCardError = false;
    },

    get dialogLoginError() {
      return state.company.dialogLoginError;
    },
    openDialogLoginError() {
      state.company.dialogLoginError = true;
    },
    closeDialogLoginError() {
      state.company.dialogLoginError = false;
    },

    get dialogUpdateJobDraft() {
      return state.company.dialogUpdateJobDraft;
    },
    openDialogUpdateJobDraft() {
      state.company.dialogUpdateJobDraft = true;
    },
    closeDialogUpdateJobDraft() {
      state.company.dialogUpdateJobDraft = false;
    },

    get dialogConfirmAccount() {
      return state.company.dialogConfirmAccount;
    },
    openDialogConfirmAccount() {
      state.company.dialogConfirmAccount = true;
    },
    closeDialogConfirmAccount() {
      state.company.dialogConfirmAccount = false;
    },

    get headerSub() {
      return state.headerSub;
    },
    toggleHeaderSub() {
      return (state.headerSub = !state.headerSub);
    },
    leaveHeaderSub() {
      return (state.headerSub = false);
    },
    onHeaderSub() {
      return (state.headerSub = true);
    },
    get isDetail() {
      return state.isDetail;
    },
    leaveIsDetail() {
      return (state.isDetail = false);
    },
    onIsDetail() {
      return (state.isDetail = true);
    },
    get currentSearchComponent() {
      return state.currentSearchComponent;
    },

    changeSearchComponent(componentName: string) {
      return (state.currentSearchComponent = componentName);
    },

    get currentBankComponent() {
      return state.currentBankComponent;
    },

    changeBankComponent(componentName: string) {
      return (state.currentBankComponent = componentName);
    },

    toggleSortModal() {
      state.sortModal = !state.sortModal;
    },

    get sortModal() {
      return state.sortModal;
    },

    get sortType() {
      return state.sortType;
    },

    changeSortType(sort_type_name: string) {
      state.sortType = sort_type_name;
    },

    get errorAlert() {
      return state.errorAlert;
    },

    setErrorAlert() {
      return;
    },

    formatNumber(number: string) {
      if (/^\d/.test(number))
        return Intl.NumberFormat("ja-JP", {
          style: "decimal"
        }).format(parseInt(number));
      return number;
    },

    formatDate(date: string){
      if(date !== null){
        date = date.replace(/(\d{4})-(\d{2})-(\d{2})/g, '$1/$2/$3')
      }else {date = ''}
      return date
    },

    formatMonth(month: string){
      if(month !== null){
        month = month.replace(/(\d{4})-(\d{2})/g, '$1/$2')
      }else {month = ''}
      return month
    }
  };
}

export type DisplayUIStore = ReturnType<typeof displayUIStore>;
